var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ccContainer",staticClass:"cc-container",attrs:{"cc-drive-type":_vm.driveType,"cc-lang-text":_vm.langText}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }